import { useState } from "react";

import { Box, Flex, Icon, SystemProps, Text } from "@storyofams/react-ui";
import Image from "next/image";
import Link from "next/link";
import { css } from "styled-components";
import { BlackLink, Star } from "~components/common/Icons";
import useMediaQuery from "~hooks/useMediaQuery";
import { CurrencyCode } from "~lib/shopify/sdk";
import { shopifyToIntlPrice } from "~lib/shopify/utils";
import { Divider, FixedRatio } from "../..";
import { Title } from "../../common/Story/blocks/Title";

type PopularProductsProps = {
  first?: boolean;
  block?: boolean;
  content: {
    title: string;
    description?: string;
    products?: any;
    resolvedProducts?: any;
  };
} & SystemProps;

export const ProductChoiceAccordion = ({
  content,
  first,
  ...props
}: PopularProductsProps) => {
  const [index, setIndex] = useState(0);
  const matchesMobile: boolean = useMediaQuery("(max-width: 360px)");
  const formatPrice = (product) => {
    if (+product?.priceRange?.minVariantPrice?.amount === 0) {
      if (product?.price) {
        return shopifyToIntlPrice({
          currencyCode: CurrencyCode.Eur,
          amount: product.price,
        });
      }
      if (product?.variants?.edges[0]?.node?.priceV2) {
        const variantPrice = product?.variants?.edges[0]?.node?.priceV2;
        return shopifyToIntlPrice(variantPrice);
      }
    }
    return shopifyToIntlPrice(product?.priceRange?.minVariantPrice);
  };
  const findDescr = () =>
    content.resolvedProducts[index].metafields?.find(
      (meta) => meta?.key === "description_excerpt"
    )?.value;
  const longDescr =
    content?.resolvedProducts &&
    content?.resolvedProducts?.length &&
    content?.resolvedProducts[index]
      ? findDescr()
      : "";
  if (
    !content.resolvedProducts ||
    (content.resolvedProducts && !content.resolvedProducts.length)
  )
    return null;
  return (
    <Box onClick={(e) => e.stopPropagation()}>
      <Box
        display={["none", "none", "block"]}
        width="100%"
        textAlign={"center"}
      >
        <Flex justifyContent={"space-between"} width={"100%"}>
          {content.resolvedProducts.map((item, index) => {
            const longDescription = item?.metafields?.find(
              (meta) => meta?.key === "description_excerpt"
            )?.value;
            return (
              <Box
                border="1px solid grey200"
                borderRadius={"md"}
                width={"48%"}
                overflow={"hidden"}
                key={item.id}
                height={"max-content"}
              >
                <Box
                  flexShrink="0"
                  position={"relative"}
                  // height={"100%"}
                  overflow={"hidden"}
                  width={"100%"}
                >
                  <FixedRatio>
                    <Image
                      objectFit="cover"
                      layout="fill"
                      src={item.image || item.images.edges[0].node.url}
                    />
                  </FixedRatio>
                </Box>
                <Box p="16px" width={"100%"} textAlign={"start"}>
                  <Link
                    href={
                      item.handle
                        ? "/products/" + item.handle
                        : "/recipes/" + item.slug
                    }
                  >
                    <Text
                      mb={"4px"}
                      fontWeight={500}
                      fontSize={2}
                      lineHeight={"22.4px"}
                      cursor={"pointer"}
                    >
                      {content.products[index]?.title}
                    </Text>
                  </Link>
                  <Text mb={1} fontSize={"12px"} lineHeight={"16.8px"}>
                    {content.products[index]?.description}
                  </Text>
                  <Divider mb={1} />
                  <Flex
                    mb={1}
                    alignItems={"center"}
                    justifyContent={"space-between"}
                  >
                    <Text
                      mr={"10px"}
                      fontWeight={500}
                      fontSize={"14px"}
                      lineHeight={"19.6px"}
                      css={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {item?.title?.text || item.title}
                    </Text>
                    <Link
                      href={
                        item.handle
                          ? "/products/" + item.handle
                          : "/recipes/" + item.slug
                      }
                    >
                      <Icon
                        cursor={"pointer"}
                        fontSize={"28px"}
                        icon={BlackLink}
                      ></Icon>
                    </Link>
                  </Flex>
                  <Flex mb={1} justifyContent={"space-between"} height={"20px"}>
                    {item?.priceRange ? (
                      <Text
                        color="#1D1D1BCC"
                        fontWeight={500}
                        height={"max-content"}
                        fontSize={"14px"}
                        lineHeight={"19.6px"}
                      >
                        {" "}
                        {item?.priceRange?.minVariantPrice?.amount !==
                        item?.priceRange?.maxVariantPrice?.amount
                          ? "Vanaf "
                          : ""}
                        {formatPrice(item)}
                      </Text>
                    ) : (
                      <Text
                        color="#1D1D1BCC"
                        fontWeight={500}
                        height={"max-content"}
                        fontSize={"14px"}
                        lineHeight={"19.6px"}
                      >
                        {"Recept"}
                      </Text>
                    )}
                    {(!!item?.metafield?.value || !!item?.rating) && (
                      <Flex>
                        <Text pt="2px" fontWeight={500} fontSize={"14px"}>
                          {item?.metafield?.value || item?.rating}
                        </Text>
                        <Icon fontSize={"14px"} color="oldPink" icon={Star} />
                      </Flex>
                    )}
                  </Flex>
                  <Text
                    fontSize={"12px"}
                    lineHeight={"16.8px"}
                    color={"#1D1D1BCC"}
                    style={{
                      display: "-webkit-box",
                      //@ts-ignore
                      "-webkit-line-clamp": "3",
                      "-webkit-box-orient": "vertical",
                      overflow: "hidden",
                    }}
                  >
                    {item?.description?.text
                      ? item?.description?.text.replace(/<\/?[^>]+(>|$)/g, " ")
                      : !longDescription
                      ? item.description
                      : longDescription.replace(/<\/?[^>]+(>|$)/g, " ")}
                  </Text>
                </Box>
              </Box>
            );
          })}
        </Flex>
      </Box>
      <Box display={["block", "block", "none"]} width="100%">
        <Box border="1px solid black" borderRadius={"5px"} mb={2}>
          <Flex textAlign={"center"} height={"42px"} p={"2px"}>
            <Box
              onClick={() => setIndex(0)}
              cursor={"pointer"}
              px="14px"
              py="7px"
              flexGrow={1}
              fontSize={2}
              fontWeight={500}
              borderRadius={"5px"}
              backgroundColor={index === 0 ? "black" : "inherit"}
              textColor={index === 0 ? "white" : "black"}
            >
              {content.products[0]?.title}
            </Box>
            <Box
              onClick={() => setIndex(1)}
              cursor={"pointer"}
              px="14px"
              fontWeight={500}
              fontSize={2}
              py="7px"
              flexGrow={1}
              borderRadius={"5px"}
              backgroundColor={index === 1 ? "black" : "inherit"}
              textColor={index === 1 ? "white" : "black"}
            >
              {content.products[1]?.title}
            </Box>
          </Flex>
        </Box>
        <Box
          border="1px solid grey400"
          borderRadius={"md"}
          key={content.resolvedProducts[index]?.id}
          overflow={"hidden"}
        >
          <Box position={"relative"} height={"188px"} width={"100%"}>
            <Image
              objectFit="cover"
              layout="fill"
              src={
                content.resolvedProducts[index]?.image ||
                content.resolvedProducts[index]?.images?.edges[0]?.node?.url
              }
            />
          </Box>
          <Box p={2} width={"100%"} textAlign={"start"}>
            <Text
              mb={"4px"}
              fontWeight={500}
              fontSize={2}
              lineHeight={"22.4px"}
            >
              {content.products[index].title}
            </Text>
            <Text mb={1} fontSize={"12px"} lineHeight={"16.8px"}>
              {content.products[index].description}
            </Text>
            <Divider mb={1} />
            <Flex mb={1} justifyContent={"space-between"} alignItems={"center"}>
              <Text
                mr={"10px"}
                fontWeight={500}
                fontSize={"14px"}
                lineHeight={"19.6px"}
                css={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {content?.resolvedProducts[index]?.title?.text ||
                  content?.resolvedProducts[index]?.title}
              </Text>
              <Link
                href={
                  content?.resolvedProducts[index]?.handle
                    ? "/products/" + content.resolvedProducts[index].handle
                    : "/recipes/" + content.resolvedProducts[index]?.slug
                }
              >
                <Icon
                  cursor={"pointer"}
                  fontSize={"28px"}
                  icon={BlackLink}
                ></Icon>
              </Link>
            </Flex>
            <Flex justifyContent={"space-between"} mb={1}>
              {content.resolvedProducts[index]?.priceRange ? (
                <Text
                  color="#1D1D1BCC"
                  fontWeight={500}
                  height={"max-content"}
                  fontSize={"14px"}
                  lineHeight={"19.6px"}
                >
                  {" "}
                  {content.resolvedProducts[index]?.priceRange?.minVariantPrice
                    ?.amount !==
                  content.resolvedProducts[index]?.priceRange?.maxVariantPrice
                    ?.amount
                    ? "Vanaf "
                    : ""}
                  {formatPrice(content.resolvedProducts[index])}
                </Text>
              ) : (
                <Text
                  color="#1D1D1BCC"
                  fontWeight={500}
                  height={"max-content"}
                  fontSize={"14px"}
                  lineHeight={"19.6px"}
                >
                  Recept
                </Text>
              )}
              {(!!content.resolvedProducts[index]?.metafield?.value ||
                !!content.resolvedProducts[index]?.rating) && (
                <Flex>
                  <Text pt="2px" fontWeight={500} fontSize={"14px"} mr={"5px"}>
                    {content.resolvedProducts[index]?.metafield?.value ||
                      content.resolvedProducts[index]?.rating}
                  </Text>
                  <Icon
                    ml={0.5}
                    fontSize={[1.75]}
                    color="oldPink"
                    icon={Star}
                  />
                </Flex>
              )}
            </Flex>
            <Text
              fontSize={"12px"}
              lineHeight={"16.8px"}
              color={"#1D1D1BCC"}
              style={{
                display: "-webkit-box",
                //@ts-ignore
                "-webkit-line-clamp": "3",
                "-webkit-box-orient": "vertical",
                overflow: "hidden",
              }}
            >
              {content.resolvedProducts[index]?.description?.text
                ? content.resolvedProducts[index]?.description?.text.replace(
                    /<\/?[^>]+(>|$)/g,
                    ""
                  )
                : !longDescr
                ? content.resolvedProducts[index].description
                : longDescr.replace(/<\/?[^>]+(>|$)/g, "")}
            </Text>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
